import vue from '../vue-event/vue-event.js';

import voice from './voice/index.js';

import Video from './video/video.js';
// import Video from './video.20210709/video.js'

let module = {
  voice,
};

vue.$on('instanceVueRouter', function(router) {
  app.router = router;
  Vue.use(Video, { router, root: module });
});

export default module;
